import { render, staticRenderFns } from "./ReservarProtocolo.vue?vue&type=template&id=c09210e2&scoped=true"
import script from "./ReservarProtocolo.vue?vue&type=script&lang=js"
export * from "./ReservarProtocolo.vue?vue&type=script&lang=js"
import style0 from "./ReservarProtocolo.vue?vue&type=style&index=0&id=c09210e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09210e2",
  null
  
)

export default component.exports